import { get, post, del, put as update } from "helpers/api_helper";
const getRoleRequest = async () => {
  return await get("/api/role");
};

export const roleService = {
  getRoleRequest,
};